// extracted by mini-css-extract-plugin
module.exports = {"fontContainer":"FontList_fontContainer__2EQvq","searchContainer":"FontList_searchContainer__1GUdo","searchTitle":"FontList_searchTitle__1SOnD","search":"FontList_search__29udB"};